'use strict';

export const CLIENT_LOADED = 'client/CLIENT_LOADED';
export const CLIENT_LOADING_FAILED = 'client/CLIENT_LOADING_FAILED';